import React from "react";
import { motion } from "framer-motion";
import { Section, SectionHeader } from "@/components/Section";
import { TESTIMONIALS } from "@/lib/constants";
import { Star, Quote } from "lucide-react";

const TestimonialCard = ({ t, idx }) => (
  <figure
    data-testid={`testimonial-${idx}`}
    className="relative shrink-0 w-80 sm:w-96 rounded-2xl border border-maple-border bg-maple-cream2 p-6 shadow-[0_10px_30px_-12px_rgba(31,45,36,0.25)]"
  >
    <Quote
      className="absolute top-5 right-5 h-6 w-6 text-maple-tan2"
      aria-hidden="true"
    />
    <div className="flex items-center gap-1" aria-label={`${t.rating} out of 5 stars`}>
      {Array.from({ length: t.rating }).map((_, i) => (
        <Star
          key={i}
          className="h-4 w-4 fill-maple-brown text-maple-brown"
          aria-hidden="true"
        />
      ))}
    </div>
    <blockquote className="mt-4 text-maple-navy/85 leading-relaxed">
      “{t.quote}”
    </blockquote>
    <figcaption className="mt-5 flex items-center gap-3">
      <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-maple-navy text-maple-cream font-serif text-lg">
        {t.name.charAt(0)}
      </span>
      <span>
        <span className="block font-semibold text-maple-navy">{t.name}</span>
        <span className="block text-xs uppercase tracking-[0.12em] text-maple-brown">
          {t.city}
        </span>
      </span>
    </figcaption>
  </figure>
);

export const Testimonials = () => {
  // Duplicate the list so the marquee loops seamlessly.
  const doubled = [...TESTIMONIALS, ...TESTIMONIALS];

  return (
    <Section id="testimonials" testId="section-testimonials">
      <SectionHeader
        kicker="Student Stories"
        title="Real reviews from GTA students."
        subtitle="Calm coaching produces confident drivers. Here's what some of our recent G2 and G students had to say."
        testId="testimonials-header"
        align="center"
      />

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="mt-12 wins-marquee py-2"
        data-testid="testimonials"
      >
        <div className="wins-track">
          {doubled.map((t, i) => (
            <TestimonialCard key={`${t.name}-${i}`} t={t} idx={i} />
          ))}
        </div>
      </motion.div>
    </Section>
  );
};
